import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { startLogout } from '../actions/auth';
import { Button, Modal, Popover } from 'antd';
import { MenuOutlined, PlusOutlined } from '@ant-design/icons';
import Avatar from 'react-avatar';
import PlansPopUp from './PlansPopUp';
import PopUp from './PopUp';
import PopOverItem from './PopOverItem';
import Logo from '../assets/images/up-logo.svg';
import '../styles/components/header.scss';
import { startGetFinance, startPaying } from '../actions/finance';
import { separator } from '../utils/separator';
import ChargePopUp from './ChargePopUp';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPlansOpen: false,
      visible: false,
      isChargeShown: false,
    };
  }
  setUpState = () => {
    const params = new URLSearchParams(this.props.location.search);
    const goal = params.get('goal');
    const planName = params.get('plan_name');
    const amount = params.get('amount');
    const yearly = params.get('yearly');
    const isChargeShown = planName ? true : false;

    this.setState(() => ({
      amount,
      planName,
      goal,
      yearly,
      isChargeShown,
    }));
  };
  hide = () => {
    this.setState({
      visible: false,
    });
  };

  handleVisibleChange = (visible) => {
    this.setState({ visible });
  };

  openPlans = () => {
    this.setState({
      isPlansOpen: true,
    });
  };

  closeCharge = () => {
    this.setState(() => ({
      isChargeShown: false,
    }));
  };

  closePlans = () => {
    this.setState({
      isPlansOpen: false,
    });
  };
  openCharge = () => {
    console.log(this.props.charged_budget);
    this.setState(() => ({
      isChargeShown: true,
    }));
  };
  startLogout = () => {
    this.props.startLogout();
  };
  render() {
    const PopOverData = [
      {
        link: '/settings',
        func: null,
        title: 'AlertCenter',
        primary: false,
      },
      {
        link: '',
        func: this.openPlans,
        title: this.props.plan_name === 'Enterprise' ? 'Plans' : 'Upgrade Plan',
        primary: this.props.plan_name === 'Enterprise' ? false : true,
      },
      {
        link: '/finance',
        func: null,
        title: 'Billing',
        primary: false,
      },
      {
        link: '',
        func: this.startLogout,
        title: 'LogOut',
        primary: false,
      },
    ];
    const showExitImpersonationButton = () => {
      const exitImpersonation = (e) => {
        localStorage.removeItem('impersonate');
        localStorage.removeItem('user');
        window.location.reload();
      };
      const isImpersonate = localStorage.getItem('impersonate') === 'true';
      if (isImpersonate) {
        return (
          <div>
            <button
              className="header__left__impersonation"
              onClick={exitImpersonation}
            >
              Exit Impersonation
            </button>
          </div>
        );
      }
    };
    return (
      <header className="header">
        <div className="header__left">
          {showExitImpersonationButton()}
          <Link className="header__title" to="/">
            <img src={Logo} alt="logo" />
            <h1>
              <strong>Up</strong>
              damus
            </h1>
          </Link>
          <Link className="header__home" to="/">
            <MenuOutlined />
          </Link>
        </div>
        {this.props.publicHeader ? undefined : (
          <div className="header__right">
            {!!String(this.props.charged_budget) && (
              <div className="header__finance">
                <span>{separator(this.props.charged_budget)}</span> Tomans
              </div>
            )}
            <Popover
              content={<Content data={PopOverData} onClose={this.hide} />}
              trigger="click"
              placement="topRight"
              visible={this.state.visible}
              onVisibleChange={this.handleVisibleChange}
            >
              <div className="header__user-area">
                <div className="header__user-data">
                  <p className="header__user-name">{this.props.email}</p>
                  <Avatar
                    className="header__user-pic"
                    email={this.props.email}
                    name={this.props.email}
                    color={Avatar.getRandomColor('sitebase', [
                      '#ffcc6b',
                      '#7e3794',
                      '#f2855c',
                    ])}
                    round={true}
                    size="32"
                  />
                </div>
              </div>
            </Popover>
          </div>
        )}
        <Modal
          visible={this.state.isChargeShown}
          onCancel={this.closeCharge}
          footer={null}
          closable={true}
        >
          <ChargePopUp
            pay={this.props.startPaying}
            amount={this.state.amount}
            goal={this.state.goal}
            planName={this.state.planName}
            period={this.state.yearly ? 'Yearly' : 'Monthly'}
            close={this.closeCharge}
            onOpenPlans={this.openPlans}
          />
        </Modal>
        {this.state.isPlansOpen ? (
          <PopUp closePopUp={this.closePlans} closeOnOutClick={false}>
            <PlansPopUp />
          </PopUp>
        ) : undefined}
      </header>
    );
  }
}

Header.defaultProps = {
  publicHeader: false,
};

const Content = (props) => (
  <div className="user-popup">
    {props.data.map((el, index) => (
      <PopOverItem
        link={el.link}
        title={el.title}
        func={el.func}
        onClick={props.onClose}
        key={el.title}
        primary={el.primary}
      />
    ))}
  </div>
);

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout()),
  startPaying: (amount, goal, planName, period) =>
    dispatch(startPaying(amount, goal, planName, period)),
});

const mapStateToProps = (state) => ({
  email: state.auth.email,
  plan_name: state.plans.subscriptions
    ? state.plans.subscriptions[0].subscription_plan.name
    : undefined,
  charged_budget: state.auth.charged_budget,
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
